import * as React from "react";

const EyeFilled = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.8359 16.6113"  {...props}>
      <g>
        <rect height={16.6113} opacity={0} width={26.8359} x={0} y={0} />
        <path d="M13.2422 16.6016C21.0645 16.6016 26.4746 10.2734 26.4746 8.30078C26.4746 6.31836 21.0547 0 13.2422 0C5.51758 0 0 6.31836 0 8.30078C0 10.2734 5.51758 16.6016 13.2422 16.6016ZM13.2422 13.7598C10.2246 13.7598 7.7832 11.3086 7.7832 8.30078C7.7832 5.2832 10.2246 2.8418 13.2422 2.8418C16.25 2.8418 18.7012 5.2832 18.7012 8.30078C18.7012 11.3086 16.25 13.7598 13.2422 13.7598ZM13.2422 10.293C14.3457 10.293 15.2344 9.4043 15.2344 8.30078C15.2344 7.19727 14.3457 6.30859 13.2422 6.30859C12.1387 6.30859 11.25 7.19727 11.25 8.30078C11.25 9.4043 12.1387 10.293 13.2422 10.293Z" />
      </g>
    </svg>
  );
};

export default EyeFilled;
